import APILibrary, { ClassExtender } from './APILibrary';
import { JobListingInterface, JobListingResource, BaseClass } from './JobListing';

/**
 * Utility interfaces
 */
export interface JobRecommendationResource extends JobListingResource {}

/**
 * Resource methods
 */
export const JobRecommendationResourceClass = <TBase extends JobListingInterface>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor {};

export class JobRecommendationResource extends ClassExtender<JobListingInterface>(
  BaseClass,
  JobRecommendationResourceClass,
) {
  static queryName = 'user_profile/job_listing_recommendations';
  static className = 'JobRecommendation';
}

/**
 * Resource instance
 */
export const JobRecommendation =
  APILibrary.createResource<JobRecommendationResource>(JobRecommendationResource);
